import { Controller } from "@hotwired/stimulus"
import consumer from "../../channels/consumer"
import type { Subscription } from "@rails/actioncable"

export default class extends Controller {
  static values = { 
    pactId: Number,
    expiresAt: String,
    refreshInterval: { type: Number, default: 1000 }
  }
  
  static targets = ["image", "countdown", "progress"]

  declare readonly pactIdValue: number
  declare expiresAtValue: string
  declare readonly refreshIntervalValue: number
  declare readonly imageTarget: HTMLImageElement
  declare readonly countdownTarget: HTMLElement
  declare readonly progressTarget: HTMLElement

  private channel?: Subscription
  private timer?: number

  connect() {
    this.subscribe()
    this.startTimer()
  }

  disconnect() {
    this.channel?.unsubscribe()
    this.stopTimer()
  }

  private subscribe() {
    this.channel = consumer.subscriptions.create(
      { channel: "PactQrChannel", pact_id: this.pactIdValue },
      {
        received: (data: any) => {
          if (data.event === "rotation") {
            this.handleRotation(data.payload)
          }
        }
      }
    )
  }

  private handleRotation(payload: any) {
    const url = new URL(this.imageTarget.src)
    url.searchParams.set("t", Date.now().toString())
    this.imageTarget.src = url.toString()

    if (payload.expires_at) {
      this.expiresAtValue = payload.expires_at
    }
  }

  private startTimer() {
    this.timer = window.setInterval(() => {
      this.updateCountdown()
    }, this.refreshIntervalValue)
  }

  private stopTimer() {
    if (this.timer) window.clearInterval(this.timer)
  }

  private updateCountdown() {
    if (!this.expiresAtValue || this.expiresAtValue === '') {
      this.countdownTarget.textContent = "--"
      return
    }
    
    const expiry = new Date(this.expiresAtValue).getTime()
    const now = new Date().getTime()
    const diff = expiry - now

    if (diff <= 0) {
      this.countdownTarget.textContent = "00"
      if (this.progressTarget) this.progressTarget.style.width = "0%"
      return
    }

    const seconds = Math.floor(diff / 1000)
    const interval = 30
    
    this.countdownTarget.textContent = seconds.toString().padStart(2, "0")
    if (this.progressTarget) {
      const percentage = Math.min(100, Math.max(0, (seconds / interval) * 100))
      this.progressTarget.style.width = `${percentage}%`
    }
  }
}
